import { Box, Step, StepLabel, Stepper } from "@mui/material";
import React from "react";
import ColorlibConnector from "./ColorlibConnector";
import ColorlibStepIcon from "./ColorlibStepIcon";

const CartStepper = ({ steps, activeStep }) => (
  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      flexGrow: 1,
      width: "100%",
      maxWidth: { sm: "100%", md: 600 },
      maxHeight: "150px",
      gap: 3,
    }}
  >
    <Stepper
      alternativeLabel
      activeStep={activeStep}
      connector={<ColorlibConnector />}
      sx={{ display: { xs: "none", md: "flex" } }}
    >
      {steps.map((label) => (
        <Step key={label}>
          <StepLabel StepIconComponent={ColorlibStepIcon}>{label}</StepLabel>
        </Step>
      ))}
    </Stepper>

    <Stepper
      alternativeLabel
      activeStep={activeStep}
      connector={<ColorlibConnector />}
      sx={{ display: { sm: "flex", md: "none" } }}
    >
      {steps.map((label) => (
        <Step key={label}>
          <StepLabel
            StepIconComponent={ColorlibStepIcon}
            componentsProps={{
              label: {
                sx: {
                  fontSize: "13px",
                  marginBottom: "15px", 
                },
              },
            }}
          >
            {label}
          </StepLabel>
        </Step>
      ))}
    </Stepper>
  </Box>
);

export default CartStepper;
